import { Controller } from "@hotwired/stimulus"

// Controller: admissoes--unsaved-guard
// Nova admissão  → avisa ao sair se algum campo foi tocado.
// Edição (persisted) → avisa apenas se algum campo foi alterado após o carregamento.
//
// Intercepta TANTO os links explícitos (confirmLeave) QUANTO qualquer
// navegação Turbo (side menu, logo, breadcrumbs, botão voltar) via
// turbo:before-visit, e o fechamento da aba via beforeunload.
export default class extends Controller {
  static values = { persisted: Boolean }

  connect() {
    this._dirty = false

    // Monitora alterações no formulário para marcar dirty
    this._onFormChange = () => { this._dirty = true }
    document.addEventListener('change', this._onFormChange, true)
    document.addEventListener('input',  this._onFormChange, true)

    // Intercepta qualquer navegação Turbo (side menu, etc.)
    this._onBeforeVisit = (ev) => this._handleBeforeVisit(ev)
    document.addEventListener('turbo:before-visit', this._onBeforeVisit)

    // Intercepta fechamento/recarga da aba
    this._onBeforeUnload = (ev) => {
      if (!this._shouldWarn()) return
      ev.preventDefault()
      ev.returnValue = ''
    }
    window.addEventListener('beforeunload', this._onBeforeUnload)
  }

  disconnect() {
    document.removeEventListener('change', this._onFormChange, true)
    document.removeEventListener('input',  this._onFormChange, true)
    document.removeEventListener('turbo:before-visit', this._onBeforeVisit)
    window.removeEventListener('beforeunload', this._onBeforeUnload)
  }

  _shouldWarn() {
    return this._dirty
  }

  async _swalConfirm() {
    return Swal.fire({
      title: "Informações não salvas",
      html: `
        <p class="text-sm text-gray-600 text-center">
          As informações preenchidas serão <strong>perdidas</strong>.<br>
          Salve o rascunho antes de sair.
        </p>`,
      icon: "warning",
      confirmButtonText: "Voltar e salvar",
      confirmButtonColor: "#3b82f6",
      showCancelButton: true,
      cancelButtonText: "Sair sem salvar",
      cancelButtonColor: "#6b7280",
      showCloseButton: true,
      reverseButtons: true,
    })
  }

  _scrollToSave() {
    const saveBtn = document.getElementById("cria-objeto")
    if (saveBtn) {
      saveBtn.scrollIntoView({ behavior: "smooth", block: "center" })
      saveBtn.focus()
    }
  }

  // Listener global para navegações Turbo não cobertas por confirmLeave
  async _handleBeforeVisit(event) {
    if (!this._shouldWarn()) return

    event.preventDefault()
    const url = event.detail.url

    const result = await this._swalConfirm()

    if (result.isConfirmed) {
      this._scrollToSave()
    } else if (result.dismiss === Swal.DismissReason.cancel) {
      this._dirty = false   // evita beforeunload ao navegar manualmente
      window.location.href = url
    }
    // X (close) → permanece na página
  }

  // Mantido para os links de aba que chamam confirmLeave explicitamente.
  // event.preventDefault() síncrono impede o Turbo de disparar before-visit,
  // evitando que os dois listeners se sobreponham.
  async confirmLeave(event) {
    if (!this._shouldWarn()) return

    event.preventDefault()
    const href = event.currentTarget.href

    const result = await this._swalConfirm()

    if (result.isConfirmed) {
      this._scrollToSave()
    } else if (result.dismiss === Swal.DismissReason.cancel) {
      this._dirty = false
      window.location.href = href
    }
  }
}
